<template>
    <div class="viewsee" >
        <div class="viewText">
            构件隐藏
            <span @click="$emit('close')">x</span>
        </div>
        <div class="con">
            <div class="createView">
                <div class="btn" @click="removeAll">全部删除</div>
            </div>
            <div class="viewArr">
                <div class="item" v-for="(item,index) in featureArr" :key="item.id" >
                    <div class="text">
                        <el-switch
                            v-model="item.show"
                            active-color="#13ce6600"
                            :width="50"
                            :active-text="item.show?'显示':''"
                            :inactive-text="!item.show?'隐藏':''"
                            inactive-color="#ff494900"
                            @change="$emit('showHidden', item)">
                        </el-switch>
                        {{item.name.split('_')[0]}}
                    </div>
                    <i class="el-icon-delete" @click="remove(index)"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:["featureArr"],
    data(){
        return {    
            
        }
    },
    mounted(){

    },
    methods:{
        removeAll(){
            this.$emit('remove')
        },
        remove(idx){
            this.$emit('remove', idx)
        }
    }
}
</script>

<style lang="less" scoped>
    .viewsee{
        position: fixed;
        right: 1vw;
        top: 17vh;
        width: 13.5vw;
        // min-height: 15vh;
        background-color: #3f3e3cCC ;
        // opacity: 0.8;
        .viewText{
            height:4vh ;
            line-height: 4vh;
            padding:0 1vw ;
            font-size: 14px;
            color: #fff ;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
            &>span{
                position: absolute;
                right: 1vw;
                top: 0vh;
                transform: scale(1.5);
                cursor: pointer;
            }
        }
        .con{
            background-color: rgba(45, 33, 33, 0.75);
            min-height: 10vh;
            color: #fff;
            .createView{
                height: 4vh;
                padding: 0.5vw;
                .btn{
                    height: 2.5vh;
                    width: 25%;
                    font-size: 12px;
                    line-height: 2.5vh;
                    text-align: center;
                    padding: 0 0.5vw;
                    border: 1px solid rgba(221, 221, 221, 0.45);
                    border-radius: 5px;
                }
                
            }
            .viewArr{
                padding: 0 0.3vw;
                .item{
                    height: 5vh;
                    font-size: 12px;
                    padding: 0 0.3vw;
                    box-sizing: border-box;
                    border-top: 1px dashed rgba(221, 221, 221, 0.45);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .text{
                        
                    }
                }
                .item:nth-child(1){
                    border-top:1px solid rgba(221, 221, 221, 0.45) ;
                }
            }
        }
    }
    /deep/.el-switch__core{
        border-color: #DCDFE6 !important;
        margin-right: 0.5vw;
    }
    /deep/.el-switch__label--left{
        position: absolute;
        transform: scale(0.8);
        left: 19px;
        white-space: nowrap;
        color: #fff;
    }
    /deep/.el-switch__label--right{
        position: absolute;
        transform: scale(0.8);
        right: 28px;
        white-space: nowrap;
        color: #fff;
    }
</style>